import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=2633a694&scoped=true"
import script from "./InputText.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputText.vue?vue&type=style&index=0&id=2633a694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633a694",
  null
  
)

export default component.exports